module.exports = __webpack_public_path__ + "static/media/CC20-AP160-12.73ac4dd0.png";